const tabFn = {}
tabFn.init = function(){
	const tabWraps = document.querySelectorAll('.tab_wrap')
	if(!!tabWraps && tabWraps.length>0){
		Array.prototype.forEach.call(tabWraps, wrap => {
			const tabItems = wrap.querySelectorAll('.tab_item')
			const tabBoxs = wrap.querySelectorAll('.tab_box')
			const tBoxFirstH = tabBoxs[0].clientHeight
			const hWrap = wrap.querySelector('.h_wrap')

			tabItems[0].classList.add('active')
			tabBoxs[0].classList.add('active')
			if(!!hWrap){
				hWrap.setAttribute('height', tBoxFirstH)
				// hWrap.setAttribute('style', `height: ${tBoxFirstH}px`)
			}

			Array.prototype.forEach.call(tabItems, item => {
				item.addEventListener('click', function(){
					this.classList.add('active');
					Array.prototype.forEach.call(tabItems, a=>{
						if(a !== this){
							a.classList.remove('active');
						}
					})
					const tId = this.getAttribute('data-id');
					const tBox = wrap.querySelector(`#${tId}`)
					const tBoxH = tBox.clientHeight
					Array.prototype.forEach.call(tabBoxs, b=>{
						if(b !== tBox){
							b.classList.remove('active');
						}
					})
					tBox.classList.add('active');
					if(!!hWrap){
						// hWrap.setAttribute('height', `${tBoxH}px`)
						// hWrap.setAttribute('style', `height: ${tBoxH}px`)
					}
				})
			})
		})
	}
}
export default tabFn;

// // tab fn
// if(document.getElementsByClassName('tab_wrap').length>=0){
// 	tabFn('tab_wrap');
// }
